import type { NskResponse } from '~/models/Api';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';

const paths = {
  create: '/vendors/vendor_partners',
  update: (id: number) => `/vendors/vendor_partners/${id}`,
  destroy: (id: number) => `/vendors/vendor_partners/${id}`
} as const;

export const create = async (ids: number[]): Promise<NskResponse<void>> =>
  postRequest(paths.create, { ids });

export const update = async (
  id: number,
  allowMessage: boolean
): Promise<NskResponse<void>> =>
  putRequest(paths.update(id), { vendorPartner: { allowMessage } });

export const destroy = async (id: number): Promise<NskResponse> =>
  deleteRequest(paths.destroy(id));
